export function signalsFilterScroll() {
  document.querySelectorAll('.signals-filter-row').forEach(function (filterRow) {
    const browse = filterRow.querySelector('.signals-browse-wrap');

    if (!browse) {
      return;
    }

    const updateLeftFade = function () {
      filterRow.classList.toggle('signals-filter-row--scrolled', browse.scrollLeft > 1);
    };

    updateLeftFade();
    browse.addEventListener('scroll', updateLeftFade, { passive: true });
  });
}
